import React from 'react'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import slugify from '@sindresorhus/slugify'
import comparePrice from '../../../utils/comparePrice'
import {
  detailsWrapper,
  imageLink,
  imageSource,
  imageWrapper,
  price,
  priceFormat,
  priceWrapper,
  productDetailsWrapper,
  productTitleTwoline,
  savePrice,
  title,
  titleWrapper,
  uStrike,
  wasPrice,
} from './product-details.module.scss'

export default function ProductDetails({ product, summary }) {
  const productSummary = summary ? summary.node : null

  const sqftPrice =
    productSummary && productSummary.variants
      ? comparePrice(productSummary.metafields, productSummary.variants[0])
      : null

  const getDecimal = (value) => {
    const whole = Math.trunc(value)
    const decimal = Math.trunc((value - whole) * 100)
    if (decimal == 0) {
      return '00'
    } else if (decimal < 10) {
      return decimal + '0'
    } else {
      return decimal
    }
  }

  return (
    <div className={productDetailsWrapper}>
      {sqftPrice && (
        <div className={imageWrapper}>
          <Link
            to={`/products/${slugify(product.handle)}`}
            className={imageLink}
          >
            <GatsbyImage
              className={imageSource}
              image={productSummary.media[0].image.gatsbyImageData}
              alt={productSummary.handle}
              title={product.title}
            />
          </Link>
        </div>
      )}
      {sqftPrice && (
        <div className={detailsWrapper}>
          <div className={titleWrapper}>
            <Link to={`/products/${slugify(product.handle)}`}>
              <div className={productTitleTwoline}>
                {/* <span className={brand}>{product.vendor}</span> */}
                <span className={title}>{product.title}</span>
              </div>
            </Link>
          </div>
          <div className={priceWrapper}>
            <div className={price}>
              <span className={priceFormat}>$</span>
              <span>
                {sqftPrice.priceSqft
                  ? Math.trunc(sqftPrice.priceSqft)
                  : Math.trunc(sqftPrice.price.toFixed(2))}
              </span>
              <span className={priceFormat}>
                {sqftPrice.priceSqft
                  ? getDecimal(sqftPrice.priceSqft) + ' /Sqft'
                  : getDecimal(sqftPrice.price.toFixed(2))}
              </span>
            </div>
            <div className={wasPrice}>
              <span className={uStrike}>
                <span>
                  $
                  {sqftPrice.comparePriceSqft
                    ? sqftPrice.comparePriceSqft + ' /Sqft'
                    : sqftPrice.comparePrice}
                </span>
              </span>
              <div className={savePrice}>
                Save{' '}
                <span>
                  $
                  {sqftPrice.priceSqft
                    ? (
                        sqftPrice.comparePriceSqft - sqftPrice.priceSqft
                      ).toFixed(2) + ' /Sqft'
                    : (sqftPrice.comparePrice - sqftPrice.price).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
